.page {
  flex: 1;
  overflow-y: auto;
  padding: 24px 28px 48px;
}
.header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 24px; }
.header h1 { display: flex; align-items: center; gap: 8px; margin: 0 0 4px; }
.header p { margin: 0; }

.center { display: flex; justify-content: center; padding: 48px; color: var(--text-muted); }
.spin { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }

.empty {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 64px 24px;
  color: var(--text-muted);
  background: var(--bg-elevated);
  border: 1px dashed var(--border);
  border-radius: var(--r-lg);
}

.group { margin-bottom: 28px; }
.groupTitle {
  font-size: var(--fs-md);
  color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.08em;
  margin: 0 0 12px;
}
.grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

.card {
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  padding: 14px 16px;
  display: flex; flex-direction: column; gap: 8px;
  transition: border-color var(--dur-fast) var(--ease), transform var(--dur-fast) var(--ease);
}
.card:hover { border-color: var(--border-strong); transform: translateY(-1px); }
.cardOn { border-color: var(--accent); background: linear-gradient(180deg, var(--accent-soft), var(--bg-elevated) 40%); }

.cardHead { display: flex; align-items: center; gap: 10px; }
.cardLogo {
  width: 36px; height: 36px;
  border-radius: var(--r-sm);
  background: var(--bg-elevated-2);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  flex: none;
}
.cardLogo img { width: 100%; height: 100%; object-fit: contain; }
.cardLogo span { font-size: var(--fs-xs); font-weight: 600; color: var(--text-muted); }
.cardChan { display: flex; flex-direction: column; line-height: 1.2; flex: 1; min-width: 0; }
.cardChan strong { font-size: var(--fs-sm); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cardTime { font-size: var(--fs-xs); color: var(--text-muted); font-variant-numeric: tabular-nums; }
.badge {
  background: var(--accent-soft);
  color: var(--accent-hover);
  font-size: var(--fs-xs); font-weight: 600;
  padding: 3px 8px; border-radius: 999px;
}
.cardTitle { font-size: var(--fs-md); margin: 4px 0 0; line-height: 1.3; }
.cardDesc {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-secondary);
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}

.cardActions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-top: 8px; }
.toggle {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: var(--fs-sm); color: var(--text-secondary);
  cursor: pointer;
}
.toggle input { accent-color: var(--accent); }
